import React, { useState } from "react";
import { Check, Minus } from "lucide-react";
import { cn } from "@/lib/utils";
import { translateFr as tfr } from "@/i18n";

function Cell({ v }) {
  if (v === true) return <Check className="h-4 w-4 text-emerald-400 mx-auto" aria-label="Inclus" />;
  if (v === false) return <Minus className="h-4 w-4 text-muted-foreground/40 mx-auto" aria-label="Non inclus" />;
  if (v === "Bientôt")
    return <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full border border-sky-500/30 text-sky-600 dark:text-sky-300/90">{tfr("Bientôt")}</span>;
  if (v === "Sur devis") return <span className="text-xs text-muted-foreground">{tfr("Sur devis")}</span>;
  if (v === "Limité") return <span className="text-xs text-amber-300/80">{tfr("Limité")}</span>;
  return <span className="text-xs text-foreground/85">{tfr(v)}</span>;
}

export default function ComparisonTable({ plans, comparison, currentPlanId }) {
  const ids = plans.map((p) => p.id);
  const [mobilePlan, setMobilePlan] = useState(currentPlanId === "pro" ? "agency" : "pro");
  const visibleMobile = (id) => id === mobilePlan || id === currentPlanId;

  return (
    <div className="mt-8" data-testid="plans-comparison">
      <h3 className="text-base font-semibold tracking-tight mb-3">{tfr("Comparer les offres en détail")}</h3>
      {/* Mobile: current plan vs. selected tab */}
      <div className="md:hidden flex gap-1.5 mb-3" role="tablist" aria-label={tfr("Choisir l'offre à comparer")}>
        {plans.map((p) => (
          <button
            key={p.id}
            role="tab"
            aria-selected={mobilePlan === p.id}
            onClick={() => setMobilePlan(p.id)}
            data-testid={`compare-tab-${p.id}`}
            className={cn(
              "flex-1 rounded-full border px-2 h-11 text-xs font-medium transition-colors",
              mobilePlan === p.id ? "bg-foreground text-background border-foreground" : "border-border text-muted-foreground"
            )}
          >
            {p.name.replace("Athlynx ", "")}
          </button>
        ))}
      </div>
      <div className="rounded-2xl border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th scope="col" className="text-left px-4 py-3 text-xs uppercase tracking-wider text-muted-foreground font-semibold sticky left-0 bg-card z-[1]">
                {tfr("Fonctionnalité")}
              </th>
              {plans.map((p) => (
                <th
                  key={p.id}
                  scope="col"
                  className={cn("px-3 py-3 text-xs font-semibold text-center whitespace-nowrap", !visibleMobile(p.id) && "hidden md:table-cell")}
                >
                  {p.name.replace("Athlynx ", "")}
                  {p.id === currentPlanId && (
                    <span className="block text-[9px] font-medium text-sky-600 dark:text-sky-300/80 normal-case tracking-normal">{tfr("Offre actuelle")}</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparison.map((g) => (
              <React.Fragment key={g.group}>
                <tr className="bg-secondary/40">
                  <th scope="rowgroup" colSpan={ids.length + 1} className="text-left px-4 py-2 text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">
                    {tfr(g.group)}
                  </th>
                </tr>
                {g.rows.map((r) => (
                  <tr key={r.label} className="border-t border-border/60">
                    <th scope="row" className="text-left px-4 py-2.5 font-normal text-foreground/85 sticky left-0 bg-card z-[1]">
                      {tfr(r.label)}
                    </th>
                    {ids.map((id) => (
                      <td key={id} className={cn("px-3 py-2.5 text-center", !visibleMobile(id) && "hidden md:table-cell")}>
                        <Cell v={r[id]} />
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
